module.exports = __webpack_public_path__ + "img/SAS_LeatherNomadShield.92a83c99.png";